// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","small":"_22zGKWmKy0aZd_9Ue1eYfN","textGrey":"#3f3f3f","separatorGrey":"#eceeee","caption":"_1dJD2pSCq2-UhXWE_3mRfd","header":"mMqpRRMLAJsgB7p2IYvsI","headerItem":"QDymvZ6l6u798DBNbQdFm _22zGKWmKy0aZd_9Ue1eYfN","articleHeader":"PJWpb4jAR17pzltcCHhFc _22zGKWmKy0aZd_9Ue1eYfN QDymvZ6l6u798DBNbQdFm _22zGKWmKy0aZd_9Ue1eYfN","deletedCard":"_2y2lRB2FNHEJ9Y6c_NT2Tb","tableCard":"_23ac1H9QXcq0QRTUOibpcW","noContentMessage":"_3RCM7ksrTOvpRlXdq9y4Wq _1dJD2pSCq2-UhXWE_3mRfd"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/cart/product-table/ProductTable.css
// module id = 416
// module chunks = 0 1 2